/* global BMS */
import operatorConfig from './configurations/operatorConfig.json';
// This object is to be injected by virgo

export const OPERATOR = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
    ? operatorConfig
    : BMS
        ? BMS.operatorConfig
        : {};



// WEBPACK FOOTER //
// ./src/constants/operator.js